import React from 'react';
import { Circle } from '@mui/icons-material';
import { Colors } from 'library';
import { Avatar, Chip, Row, Stack, Text } from 'library/ui';
import { AvailableTeacher } from 'models';
import MessageWorkerButton from 'parent-portal/messages/MessageWorkerButton';

const NO_EDUCATION = 'No education listed';

export default function AvailableTeacherCardHeader({ worker }: { worker: AvailableTeacher }) {
    const education = worker.credentials.education.filter(Boolean);
    const credentials = [
        ...(education.length && education[0] !== NO_EDUCATION ? education : ['']),
        ...[worker.credentials.experience].filter(Boolean),
        ...worker.credentials.highlights.filter(Boolean),
    ];

    return (
        <Row gap="md" align="center">
            <Avatar imageUrl={worker.pictureUrl} name={worker.name} size={48} />
            <Stack gap="sm">
                <Row gap="sm" align="center" wrap>
                    <Text weight="bold">{worker.name}</Text>
                    <Row gap="sm" align="center">
                        <Circle sx={{ fontSize: 10, color: Colors.secondary }} />
                        <Text size="sm" tone="secondary">
                            Available
                        </Text>
                    </Row>
                    <MessageWorkerButton userId={worker.id} size={28} />
                </Row>
                <Row gap="sm" wrap>
                    {credentials.filter(Boolean).map((credential) => (
                        <Chip
                            key={credential}
                            variant="filled"
                            bgColor={Colors.secondarySoft}
                            textColor={Colors.secondary}
                            size="small"
                        >
                            {credential}
                        </Chip>
                    ))}
                </Row>
            </Stack>
        </Row>
    );
}
